import { render, staticRenderFns } from "./UpsertDisbursementConfig.vue?vue&type=template&id=3ebeb202"
import script from "./UpsertDisbursementConfig.vue?vue&type=script&lang=js"
export * from "./UpsertDisbursementConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports